import React from "react";
import { View, Image, StyleSheet } from "react-native";
import { Lock } from "lucide-react-native";
import { colors } from "../theme";

// Native sticker badge. Renders the designer's exported artwork — each PNG
// already contains its own tinted circle, so this draws no background of its
// own for an earned sticker.
//
// The requires are an explicit map because Metro resolves `require` statically:
// a computed path (`require(`../assets/stickers/${key}.png`)`) does not bundle.
const ART: Record<string, number> = {
  first_star: require("../assets/stickers/first_star.png"),
  perfect_ten: require("../assets/stickers/perfect_ten.png"),
  quiz_whiz: require("../assets/stickers/quiz_whiz.png"),
  super_brain: require("../assets/stickers/super_brain.png"),
  first_show: require("../assets/stickers/first_show.png"),
  movie_buff: require("../assets/stickers/movie_buff.png"),
  on_a_roll: require("../assets/stickers/on_a_roll.png"),
  week_star: require("../assets/stickers/week_star.png"),
  numbers_hero: require("../assets/stickers/numbers_hero.png"),
  letters_hero: require("../assets/stickers/letters_hero.png"),
  colors_hero: require("../assets/stickers/colors_hero.png"),
  shapes_hero: require("../assets/stickers/shapes_hero.png"),
  social_hero: require("../assets/stickers/social_hero.png"),
  language_hero: require("../assets/stickers/language_hero.png"),
  bedtime_hero: require("../assets/stickers/bedtime_hero.png"),
  creativity_hero: require("../assets/stickers/creativity_hero.png"),
};

export function StickerMedallion({
  stickerKey,
  earned,
  size = 64,
}: {
  stickerKey: string;
  earned: boolean;
  size?: number;
}) {
  const art = ART[stickerKey];

  // Locked, or a key with no artwork yet (a sticker added to the backend
  // catalog before its art lands) — dashed circle with a lock.
  if (!earned || !art) {
    return (
      <View
        style={[
          styles.locked,
          { width: size, height: size, borderRadius: size / 2 },
        ]}
      >
        <Lock
          size={Math.round(size * 0.38)}
          color={colors.ink3}
          strokeWidth={2.25}
        />
      </View>
    );
  }

  return (
    <Image
      source={art}
      style={{ width: size, height: size }}
      resizeMode="contain"
      accessibilityIgnoresInvertColors
    />
  );
}

const styles = StyleSheet.create({
  locked: {
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: colors.bgWarm,
    borderWidth: 2,
    borderColor: colors.line,
    // Dashed reads as "not yet earned" without needing a second colour.
    borderStyle: "dashed",
  },
});

export default StickerMedallion;
